import React, { useEffect, useState } from "react"
import { Text, View, TextInput } from "react-native";
import AppStyles from "../../../AppStyles";
import { store } from "../../../store/store";
import { updateReduxCurrentAnswer, updateQuestionRenderState } from "../../services/redux/commonRedux";
import { getConsultationAnsValue } from "../../services/econsult/EConsultUtils";

export default function InputFeildFunc() {

    const [data, updateData] = useState({
        ansData : {},
        questionData : {},
        render : false
    })

    const [inputText, updateInputText] = useState('');

    function onChangeText(questionData : any, text = '') {
        const id = questionData['qid'];
        const rskey = questionData['rskey'];
        const ansVal = text;
        const curretAns = {
            [id] : {
                id : questionData['qid'],
                [rskey] : ansVal,
                textInput : {}
            },
        }; updateData({
            questionData : questionData,
            ansData : {},
            render : true
        }); updateReduxCurrentAnswer(curretAns);
    }

    useEffect(() => {
        const reduxState = store.getState();
        if (reduxState.renderQuestionElement) {
            updateQuestionRenderState(false);
            if(reduxState.currentConsultationQuestion) {
                const ansData = reduxState.currentConsultationAnswer;
                const qData = reduxState.currentConsultationQuestion;
                if (ansData[qData['qid']]) 
                    updateInputText(getConsultationAnsValue(qData, ansData) ?? '');
                else 
                    updateInputText('');
                updateData({
                    ansData : ansData,
                    questionData : qData,
                    render : true
                });
            }
        }
    })

    return <View style={{marginBottom: 60}}>
        {
            data.render ? <View>
                <View style= {{marginHorizontal: 16}}>
                    <Text style={AppStyles.questionText}>
                        {data.questionData['qstr']}
                    </Text>
                    <TextInput style={[AppStyles.quesInput, {padding: 8}]}
                        multiline
                        autoFocus={true}
                        numberOfLines={8}
                        placeholder={data.questionData['hint']}
                        // defaultValue= {inputText}
                        value={inputText} 
                        onChangeText={text => {
                            onChangeText(data.questionData, text.trim())
                            updateInputText(text)
                        }}
                    />
                </View>
            </View> : <View></View>
        }
    </View>
}